import { useEffect, useState } from "react";

import Cookies from "js-cookie";


// Reusable Circular Progress Component
function CircularProgress({ value, max, label, color }) {
  const radius = 50;
  const strokeWidth = 8;
  const circumference = 2 * Math.PI * radius;
  const progress = (value / max) * circumference;

  return (
    <div className="tc">
      <svg width="120" height="120" className="mb3">
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke="#e5e7eb" // gray background
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
          transform="rotate(-90 60 60)"
        />
        <text
          x="60"
          y="65"
          textAnchor="middle"
          className="f4 fw6 dark-gray"
        >
          {value}
        </text>
      </svg>
      <div className="f6 gray">{label}</div>
    </div>
  );
}

export default function RecordsDashboard() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    //fetch agents
    const fetchAll = () => {
      let adminCookie = Cookies.get("sessioniduser");
      if (adminCookie.length >= 1) {
        setLoading(true);

        setTimeout(() => {
          fetch("https://api.terraweb.africa/getRecords", {
            method: "post",
            headers: { "Content-Type": "application/JSON" },
            body: JSON.stringify({
              userid: adminCookie,
            }),
          })
            .then(function (response) {
              if (response.status === 400) {
                throw Error("Wrong credentials");
              }
              if (response === 500) {
                throw Error("Could not complete request because of an error");
              }

              return response.json();
            })
            .then((user) => {
              if (user[0].id >= 1) {
                //load data



                //new way to update the state event without duplicates
                // Update events using setEvents, excluding duplicates
               
                setRecords(user);
        setLoading(false);
              } else {
                //dont load

              
                setLoading(null);
              }
            })
            .catch((err) => {
              // setFoundErr(err.message);
              setLoading(null);
              // setFlag(1);
            });
        }, 2000);
      } else {
        setLoading(null);
      }
    };

    fetchAll();
  }, []);

  const totalRecords = records.length;
//   const totalWeight = records.reduce((sum, r) => sum + (r.weight || 0), 0);

// ✅ Safely sum weights, converting string -> number
const totalWeight = records.reduce(
  (sum, r) => sum + (parseFloat(r.weight) || 0),
  0
).toFixed(2); // Keep two decimal places

// ✅ Dynamic max for progress bar: take the highest value + buffer
const weightMax = totalWeight > 0 ? totalWeight * 1.2 : 100; 
const recordsMax = totalRecords > 0 ? totalRecords * 1.2 : 100;

  // if (loading) return <div className="pa4 gray">Loading...</div>;

  return (
    <div className="pa0">
      {/* Progress Circles */}
      <div className="flex flex-wrap justify-center gap4">
  <CircularProgress
    value={totalRecords}
    max={recordsMax}
    label="Total Records"
    color="#3b82f6" // blue
  />
  <CircularProgress
    value={totalWeight}
    max={weightMax}
    label="Total Weight (kg)"
    color="#10b981" // green
  />
</div>


    
    </div>
  );
}
